import React from 'react';
import Badge from './ui/Badge';
import Button from './ui/Button';
import Avatar from './ui/Avatar';
import RiskIndicator from './ui/RiskIndicator';

export default function StudentHeader({ student, onBack, onEdit, onExport, onForward }) {
  if (!student) return null;
  return (
    <div className="sticky top-24 z-20 sp-header">
      <div className="px-6 py-4">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-4">
            <Avatar name={student.name} size="lg" color="slate" />
            <div>
              <div className="flex items-center gap-3 flex-wrap">
                <h1 className="sp-value" style={{ fontSize: '20px', fontWeight: 600 }}>{student.name}</h1>
                <Badge variant={student.status === 'Under Review' ? 'review' : student.status === 'Archived' ? 'inactive' : 'active'}>
                  {student.status}
                </Badge>
              </div>
              <div className="flex items-center gap-3 text-sm sp-muted flex-wrap">
                <span>Age {student.age || 'N/A'}</span>
                <span> - </span>
                <span>{student.pronouns || 'Pronouns not set'}</span>
                <span> - </span>
                <span>{student.school || 'School not set'}</span>
              </div>
              <div className="mt-2">
                <RiskIndicator level={student.riskLevel} />
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="secondary" size="sm" onClick={onBack} type="button">
              Back to list
            </Button>
            {onExport && (
              <Button variant="secondary" size="sm" onClick={onExport} type="button">
                Export history
              </Button>
            )}
            {onForward && (
              <Button variant="secondary" size="sm" onClick={onForward} type="button">
                Forward internally
              </Button>
            )}
            <Button size="sm" onClick={onEdit} type="button">
              Edit Profile
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
